import React from 'react';
import { Col, Row } from '@perxis-auto/ui-kit/lib/components/Grid';
import { Typography } from '@perxis-auto/ui-kit/lib/components/Typography';

import formatGroupedFilterValue from '@/features/filters/helpers/formatGroupedFilterValue';
import useFiltersData from '@/features/filters/hooks/useFiltersData';
import { useAppSelector } from '@/features/hooks';
import { rootSelectors } from '@/features/store';

import FilterItem from '../FilterItem';

import { FilterItemGroupProps } from './FilterItemGroup.types';

import styles from './FilterItemGroup.module.scss';

/**
 * Компонент, отрисовывающий элемент фильтра,
 * либо группу элементов фильтра, если фильтр задан группой.
 */
function FilterItemGroup({ filterKey, onChange }: FilterItemGroupProps) {
  const { currentData, data: filters = currentData } = useFiltersData();

  const groupedFilterItems = useAppSelector(state =>
    rootSelectors.filters.groupedFilterItemSelector(state, {
      filterKey,
      filtersData: filters?.data,
    }),
  );

  if (!groupedFilterItems || !groupedFilterItems.length) {
    return null;
  }

  const isDependencyFulfilled = groupedFilterItems.some(
    item => item.isDependencyFulfilled,
  );

  if (!isDependencyFulfilled) {
    return (
      <Typography.Paragraph level="small" color="dark-light">
        {groupedFilterItems[0].dependencyText}
      </Typography.Paragraph>
    );
  }

  if (groupedFilterItems.length < 2) {
    return <FilterItem item={groupedFilterItems[0]} onChange={onChange} />;
  }

  return (
    <Row gutter={[0, 'vertical-sky']} className={styles.filterItemGroup}>
      {groupedFilterItems.map((item, index) => {
        const otherFilterItems = [...groupedFilterItems];
        otherFilterItems.splice(index, 1);
        return (
          <Col key={`${String(index)}`} span={24}>
            <Row gutter={[0, 'vertical-blue']}>
              {!!item.groupTitle && (
                <Col span={24}>
                  <Typography.Text
                    level="main"
                    color="darkest"
                    className={styles.filterItemGroupTitle}
                  >
                    {item.groupTitle}
                  </Typography.Text>
                </Col>
              )}
              <Col span={24}>
                <FilterItem
                  item={item}
                  formatFilterValue={formatGroupedFilterValue(otherFilterItems)}
                  onChange={onChange}
                />
              </Col>
            </Row>
          </Col>
        );
      })}
    </Row>
  );
}

export default FilterItemGroup;
